document.addEventListener('DOMContentLoaded', function() {
  var productImages = document.querySelectorAll('img[data-second-image]'); // Selecciona todas las imágenes con segunda imagen

  productImages.forEach(function(image) {
    var originalSrc = image.src; // Guardamos la imagen original
    var secondImageSrc = image.getAttribute('data-second-image'); // Obtenemos la segunda imagen
    var touched = false; // Para controlar si la imagen ya fue tocada

    // Función para alternar entre la imagen original y la segunda imagen
    function toggleImage() {
      if (image.src === originalSrc) {
        image.src = secondImageSrc;
      } else {
        image.src = originalSrc;
      }
    }

    // Detectar si es un dispositivo móvil (pantalla táctil)
    if ('ontouchstart' in window || navigator.maxTouchPoints) {
      console.log("Dispositivo móvil detectado");

      // Manejar el toque en la imagen
      image.addEventListener('click', function(event) {
        if (!touched) {
          event.preventDefault(); // Evitar la redirección en el primer toque
          toggleImage(); // Alternar la imagen
          touched = true; // Marcar que ha sido tocada
        } else {
          // Permitir la redirección en el segundo toque
          window.location.href = image.closest('a').href;
        }
      });

      // Restablecer después de un tiempo para permitir un segundo clic
      image.addEventListener('mouseleave', function() {
        touched = false; // Restablecer para permitir el segundo clic
      });

    } else {
      // Funcionalidad de hover para desktop
      image.addEventListener('mouseenter', function() {
        image.src = secondImageSrc;
      });

      image.addEventListener('mouseleave', function() {
        image.src = originalSrc;
      });
    }
  });
});

document.addEventListener("DOMContentLoaded", function () {
   const tabs = document.querySelectorAll('.tabs a');
   const contents = document.querySelectorAll('.tab-content');

   tabs.forEach(tab => {
      tab.addEventListener('click', function (e) {
         e.preventDefault();

         tabs.forEach(t => t.classList.remove('active'));
         contents.forEach(c => c.classList.remove('active'));

         tab.classList.add('active');
         document.querySelector(tab.getAttribute('href')).classList.add('active');
      });
   });

   // Activar la primera pestaña por defecto
   tabs[0].classList.add('active');
   contents[0].classList.add('active');
});




